import React, { useState, useEffect } from 'react';
import api from '../api';

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Стан для редагування
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ author_name: '', rating: 5, text: '' });

  // Завантаження відгуків
  const fetchReviews = () => {
    setLoading(true);
    api.get('/reviews')
      .then(res => setReviews(res.data))
      .catch(err => alert('Помилка завантаження відгуків: ' + err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // Видалення
  const handleDelete = (id) => {
    if (!window.confirm('Точно видалити цей відгук?')) return;
    
    api.delete(`/reviews/${id}`)
      .then(() => fetchReviews())
      .catch(err => alert('Помилка видалення: ' + err.message));
  };

  // Початок редагування
  const handleEditClick = (review) => {
    setEditingId(review.id);
    setEditForm({ author_name: review.author_name, rating: review.rating, text: review.text });
  };

  // Збереження змін
  const handleSaveEdit = (id) => {
    api.put(`/reviews/${id}`, editForm)
      .then(() => {
        setEditingId(null);
        fetchReviews();
      })
      .catch(err => alert('Помилка збереження: ' + err.message));
  };

  if (loading) return <div style={{ padding: 20 }}>Завантаження відгуків...</div>;

  return (
    <div style={{ padding: '20px 40px', maxWidth: 900 }}>
      <h2 style={{ marginBottom: 20, fontFamily: "'Fraunces', serif" }}>Керування відгуками</h2>
      
      {reviews.length === 0 ? (
        <div style={{ color: '#666' }}>Поки немає жодного відгуку.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {reviews.map(review => (
            <div key={review.id} style={{ 
              background: '#fff', padding: 20, borderRadius: 12, 
              border: '1px solid #ddd', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' 
            }}>
              {editingId === review.id ? (
                // --- ФОРМА РЕДАГУВАННЯ ---
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <input 
                    value={editForm.author_name} 
                    onChange={e => setEditForm({...editForm, author_name: e.target.value})}
                    style={{ padding: 8, borderRadius: 6, border: '1px solid #ccc' }}
                  />
                  <select 
                    value={editForm.rating} 
                    onChange={e => setEditForm({...editForm, rating: Number(e.target.value)})}
                    style={{ padding: 8, borderRadius: 6, border: '1px solid #ccc' }}
                  >
                    {[5,4,3,2,1].map(num => <option key={num} value={num}>{num} Зірок</option>)}
                  </select>
                  <textarea 
                    value={editForm.text} 
                    onChange={e => setEditForm({...editForm, text: e.target.value})}
                    style={{ padding: 8, borderRadius: 6, border: '1px solid #ccc', minHeight: 80 }}
                  />
                  <div style={{ display: 'flex', gap: 10 }}>
                    <button onClick={() => handleSaveEdit(review.id)} style={{ padding: '8px 16px', background: '#22c55e', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Зберегти</button>
                    <button onClick={() => setEditingId(null)} style={{ padding: '8px 16px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Скасувати</button>
                  </div>
                </div>
              ) : (
                // --- РЕЖИМ ПЕРЕГЛЯДУ ---
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ fontWeight: 'bold', fontSize: 18 }}>{review.author_name}</div>
                    <div style={{ color: '#f59e0b', fontSize: 18 }}>{'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}</div>
                  </div>
                  <div style={{ color: '#444', marginBottom: 16, lineHeight: 1.5 }}>{review.text}</div>
                  <div style={{ fontSize: 12, color: '#999', marginBottom: 16 }}>
                    Дата: {new Date(review.created_at).toLocaleString('uk-UA')}
                  </div>
                  
                  <div style={{ display: 'flex', gap: 10 }}>
                    <button onClick={() => handleEditClick(review)} style={{ padding: '6px 12px', background: '#eab308', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Редагувати</button>
                    <button onClick={() => handleDelete(review.id)} style={{ padding: '6px 12px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Видалити</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
